import { BrowserCacheLocation, Configuration } from '@azure/msal-browser'
import { msal } from '../environment/Config.json'

export const GetMsalConfiguration = (isSimulation: boolean): Configuration => {
  return {
    auth: {
      clientId: msal.clientid,
      authority: msal.authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin
    },
    cache: {
      cacheLocation: isSimulation ? BrowserCacheLocation.LocalStorage : BrowserCacheLocation.SessionStorage
    },
    telemetry: {
      application: {
        appName: msal.appname,
        appVersion: msal.appversion
      }
    }
  }
}
